import { AbstractControl, ValidationErrors } from '@angular/forms';

export function passwordExpiredValidator(control: AbstractControl): ValidationErrors | null {
  const value: string = control.value || '';

  const lengthValid = value.length >= 12 && value.length <= 20;
  const hasUppercase = /[A-Z]/.test(value);
  const hasNumber = /[0-9]/.test(value);
  const hasSpecialChar = /[!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/.test(value);

  const errors: ValidationErrors = {};
  if (!lengthValid) errors.length = true;
  if (!hasUppercase) errors.uppercase = true;
  if (!hasNumber) errors.number = true;
  if (!hasSpecialChar) errors.special = true;

  return Object.keys(errors).length > 0 ? errors : null;
}